module.exports = __webpack_public_path__ + "static/media/fishing-rod-1.dbfc06ac.glb";